module.exports = __webpack_public_path__ + "fonts/Poppins-Thin.25cd0f68.ttf";